import { Laptop } from 'lucide-react';
import { useMacApprovals, useResolveMacApproval } from '../lib/mac';

const ACTION: Record<string, string> = {
  mac_run_command: 'Выполнить команду',
  mac_write_file: 'Записать файл',
  mac_make_dir: 'Создать папку',
  mac_move: 'Переместить',
  mac_delete: 'Удалить',
};

/** Mac tool calls waiting for the owner's decision («Спрашивать» / «Авто»). */
export function MacApprovals({ sessionId, active }: { sessionId: string; active: boolean }) {
  const { data } = useMacApprovals(sessionId, active);
  const resolve = useResolveMacApproval(sessionId);
  if (!active || !data?.length) return null;
  return (
    <div className="mb-2 flex flex-col gap-2">
      {data.map((a) => (
        <section
          key={a.id}
          aria-label="Запрос доступа к Маку"
          className="mc-menu-enter origin-bottom rounded-2xl border border-primary/40 bg-surface p-3 shadow-sm"
        >
          <div className="flex items-center gap-2 text-[13px] font-medium">
            <Laptop size={14} className="shrink-0 text-primary" />
            <span className="min-w-0 truncate">{ACTION[a.tool] ?? a.tool} на Маке?</span>
          </div>
          <pre className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-all rounded-lg bg-subtle p-2 font-mono text-[12px] leading-relaxed">
            {a.summary}
          </pre>
          {a.detail && <div className="mt-1 text-[12px] text-muted-foreground">{a.detail}</div>}
          <div className="mt-2 flex justify-end gap-2">
            <button
              type="button"
              disabled={resolve.isPending}
              onClick={() => resolve.mutate({ id: a.id, approve: false })}
              className="mc-press min-h-11 rounded-full border border-border px-4 text-[14px] hover:bg-subtle disabled:opacity-60"
            >
              Отклонить
            </button>
            <button
              type="button"
              disabled={resolve.isPending}
              onClick={() => resolve.mutate({ id: a.id, approve: true })}
              className="mc-press min-h-11 rounded-full bg-primary px-4 text-[14px] text-primary-foreground disabled:opacity-60"
            >
              Разрешить
            </button>
          </div>
        </section>
      ))}
    </div>
  );
}
